(function () {
  var SELECTOR = '[data-th-testimonial-carousel]';

  function initCarousel(root) {
    if (!root) return;
    if (root.__thTestimonialInit) return;
    root.__thTestimonialInit = true;

    var wrap = root.querySelector('.th-testimonial__track-wrap');
    var track = root.querySelector('.th-testimonial__track');
    var dots = Array.from(root.querySelectorAll('.th-testimonial__dot'));
    var progBar = root.querySelector('.th-testimonial__progress-bar');
    if (!wrap || !track) return;

    // Strip any clones left from a prior init (theme-dev re-renders, etc.)
    track.querySelectorAll('[data-th-clone]').forEach(function (n) { n.remove(); });

    var realCards = Array.from(track.querySelectorAll('.th-testimonial__card'));
    var total = realCards.length;
    if (total < 2) return;

    var firstClone = realCards[0].cloneNode(true);
    var lastClone  = realCards[total - 1].cloneNode(true);
    [firstClone, lastClone].forEach(function (c) {
      c.dataset.thClone = 'true';
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-section-block-id');
    });
    track.appendChild(firstClone);
    track.insertBefore(lastClone, realCards[0]);

    var vis = 1; // 0 = lastClone, 1..N = real cards, N+1 = firstClone
    var realIdx = 0;

    function applyTransform() {
      var first = track.children[0];
      if (!first) return;
      var cardW = first.offsetWidth;
      var gap   = parseFloat(getComputedStyle(track).columnGap) || 0;
      var wrapW = wrap.offsetWidth;
      var tx    = -(vis * (cardW + gap)) + (wrapW - cardW) / 2;
      track.style.transform = 'translateX(' + tx + 'px)';
    }

    function updateDots() {
      dots.forEach(function (d, i) {
        var on = i === realIdx;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function updateCards() {
      Array.from(track.children).forEach(function (c, i) {
        c.classList.toggle('is-active', i === vis);
      });
    }

    // The CSS animation lives inline on the bar as
    //   "th-bar-fill-v3 8s linear infinite"
    // and it's `infinite`, so for AUTO-advances we don't touch it —
    // the loop continues by itself and we ride the iteration boundary.
    // For MANUAL advances (button/dot/swipe) we restart it so the user
    // sees a full fresh 8s on the new card.
    var BAR_ANIM = 'th-bar-fill-v3 8s linear infinite';
    var isPaused = false;
    var holdActive = false;

    function pauseProgress() {
      if (!progBar || isPaused) return;
      isPaused = true;
      progBar.style.animationPlayState = 'paused';
    }

    function resumeProgress() {
      if (!progBar || !isPaused) return;
      isPaused = false;
      progBar.style.animationPlayState = 'running';
    }

    function restartProgress() {
      if (!progBar) return;
      progBar.style.animation = 'none';
      // force reflow so the browser registers the cancel
      // eslint-disable-next-line no-unused-expressions
      progBar.offsetWidth;
      progBar.style.animation = BAR_ANIM;
      if (isPaused) progBar.style.animationPlayState = 'paused';
    }

    function holdStart() {
      holdActive = true;
      pauseProgress();
    }

    function holdEnd() {
      if (!holdActive) return;
      holdActive = false;
      resumeProgress();
    }

    function move(dir, opts) {
      vis += dir;
      realIdx = ((vis - 1) % total + total) % total;
      applyTransform();
      updateCards();
      updateDots();
      if (opts && opts.manual) restartProgress();
    }

    function goTo(index) {
      vis = index + 1;
      realIdx = index;
      applyTransform();
      updateCards();
      updateDots();
      restartProgress();
    }

    function jumpTo(nextVis) {
      vis = nextVis;
      realIdx = ((vis - 1) % total + total) % total;
      track.style.transition = 'none';
      applyTransform();
      updateCards();
      updateDots();
      // force reflow before re-enabling transition
      // eslint-disable-next-line no-unused-expressions
      track.offsetWidth;
      track.style.transition = '';
    }

    track.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      if (vis <= 0) jumpTo(total);
      else if (vis >= total + 1) jumpTo(1);
    });

    // Auto-advance: the bar's CSS animation is `infinite`, so each loop
    // boundary fires `animationiteration`. Ride that instead of running
    // our own timer — guarantees the bar and slide stay in lockstep.
    if (progBar) {
      progBar.addEventListener('animationiteration', function () {
        if (isPaused) return;
        move(1, { manual: false });
      });
    }

    var prev = root.querySelector('.th-testimonial__btn--prev');
    var next = root.querySelector('.th-testimonial__btn--next');
    if (prev) prev.addEventListener('click', function (e) { e.currentTarget.blur(); move(-1, { manual: true }); });
    if (next) next.addEventListener('click', function (e) { e.currentTarget.blur(); move(1, { manual: true }); });

    dots.forEach(function (d, i) {
      d.addEventListener('click', function (e) { e.currentTarget.blur(); goTo(i); });
    });

    // Desktop: press-and-hold on a card pauses the timer until release.
    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      if (!e.target.closest('.th-testimonial__card')) return;
      holdStart();
    });
    document.addEventListener('mouseup', holdEnd);

    // Mobile: press-and-hold anywhere on the carousel viewport pauses until release.
    var swipeStartX = 0;
    wrap.addEventListener('touchstart', function (e) {
      swipeStartX = e.touches[0].clientX;
      holdStart();
    }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - swipeStartX;
      holdEnd();
      if (Math.abs(dx) > 40) move(dx < 0 ? 1 : -1, { manual: true });
    }, { passive: true });
    wrap.addEventListener('touchcancel', holdEnd, { passive: true });

    new ResizeObserver(applyTransform).observe(wrap);

    track.style.transition = 'none';
    requestAnimationFrame(function () {
      applyTransform();
      updateCards();
      updateDots();
      requestAnimationFrame(function () { track.style.transition = ''; });
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
